import React, { useMemo } from 'react';
import { Box, Grid } from '@mui/material';

import { usersServices } from '@services';
import { asyncForEach, isImageFile, showError } from '@utils';

import UserMediaDocument from './UserMediaDocument';
import UserMediaUploadDocument from './UserMediaUploadDocument';

import styles from './userMedia.styles';

const UserMedia = ({ userLoading, userId, details, getUser }) => {
  const [isUploading, setIsUploading] = React.useState(false);
  const documents = useMemo(() => {
    const driverDocuments = details?.driverDocuments || [];
    const financialDocuments = details?.financialDocuments || [];
    return [...driverDocuments, ...financialDocuments];
  }, [details]);

  const handleClickItem = (file) => {
    if (window && file.url) {
      window.open(file.url, '_blank');
    }
  };

  const handleUploadDocument = async (data) => {
    try {
      setIsUploading(true);
      await asyncForEach(data.documents, async (document) => {
        await usersServices.uploadUserDocument(userId, document, data?.type);
      });
      await getUser();
    } catch (error) {
      showError(error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleDeleteFile = async (document) => {
    const documentId = document.id;

    try {
      await usersServices.deleteUserDocument(userId, documentId);
      await getUser();
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Box sx={styles.userMediaWrapper}>
      <Box sx={styles.userMediaButtonWrapper}>
        <UserMediaUploadDocument
          onSubmit={handleUploadDocument}
          isLoading={userLoading || isUploading}
        />
      </Box>
      {documents.length === 0 && 'No documents uploaded'}
      <Grid container rowSpacing={4} columnSpacing={1.5}>
        {documents.map((doc) => {
          const isImageType = isImageFile(doc?.filename);

          return (
            <Grid key={doc.id} item xs={12} sm={6} md={4} lg={3}>
              {isImageType ? (
                <UserMediaDocument
                  enablePreviewFile
                  file={doc}
                  files={documents}
                  onDeleteFile={handleDeleteFile}
                />
              ) : (
                <UserMediaDocument
                  file={doc}
                  files={documents}
                  onClickFile={handleClickItem}
                  onDeleteFile={handleDeleteFile}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default UserMedia;
